module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAYAAADgkQYQAAAAjElEQVQYlYXQMWpCURCF4e+6lhHx8gjYCTauIb1YuaUsw60IIZjiLeakyJXIK8zAFP9h5sxhWtQJXzLfLKutd5hWmHHR1n0x0HHBLImoTdRH1DR4GrxJoiV5bG7xjjs6rjJ/w6/To9UhKlGHZ331lGGL43A7Dvbn9E8mUfsh9MXpPvR9izrj88Wf3n4AxS1jUtGm0/YAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/cancel.png
// module id = l9mc
// module chunks = 1